import add from 'date-fns/add';
import isFuture from 'date-fns/isFuture';
import { atom, useAtom } from 'jotai';
import { useCallback, useState } from 'react';

type Entry<T> = { value: T; expires: Date };

const expiryAtom = atom<{ [key: string]: Entry<any> }>({});

const useExpiringState = <T>(key: string, defaultValue: T, timeout: number) => {
  const [registry, setRegistry] = useAtom(expiryAtom);

  const getInitialValue = useCallback(() => {
    const entry = registry[key];
    return entry && isFuture(entry.expires) ? (entry.value as T) : defaultValue;
  }, [key, registry, defaultValue]);

  const [state, setState] = useState(getInitialValue());

  const update = useCallback(
    (value: T) => {
      const entry = { value, expires: add(new Date(), { seconds: timeout }) };
      setRegistry((r) => ({ ...r, [key]: entry }));
      setState(value);
    },
    [key, setRegistry, setState, timeout]
  );

  return [state, update] as const;
};

export default useExpiringState;
